// Valor para cálculo do DV conforme tabela SERPRO: ASCII - 48
// 0-9 → 0-9; A → 17, B → 18, ..., Z → 42
function charToInt(c: string): number {
  return c.toUpperCase().charCodeAt(0) - 48;
}

function calcDV(chars: string, weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < chars.length; i += 1) {
    sum += charToInt(chars[i]) * weights[i];
  }
  const r = sum % 11;
  return r < 2 ? 0 : 11 - r;
}

const WEIGHTS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export default function validaCnpj(s: string): boolean {
  const cnpj = s.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (!cnpj || cnpj.length !== 14) return false;

  // Os 2 dígitos verificadores devem ser numéricos
  if (!/^\d{2}$/.test(cnpj.slice(12))) return false;

  // Rejeita sequências com todos os caracteres iguais
  if (/^(.)\1{13}$/.test(cnpj)) return false;

  const base = cnpj.slice(0, 12);
  const dv1 = calcDV(base, WEIGHTS_DV1);
  const dv2 = calcDV(base + dv1, WEIGHTS_DV2);

  return parseInt(cnpj[12], 10) === dv1 && parseInt(cnpj[13], 10) === dv2;
}
